import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from '@shared/services/api/profile.service';
import { take, tap } from 'rxjs';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @Input() username = '';
  @Input() subtitle?: string = '';
  @Input() mode: 'full' | 'short' | 'final-user' = 'full';

  isAdmin = false;
  avatar: string | null = null;

  constructor(
    public translateService: TranslateService,
    private _profileService: ProfileService
  ) {}

  ngOnInit(): void {
    if (this.mode === 'final-user') {
      return;
    }
    this._profileService.profile$
      .pipe(
        take(1),
        tap((profile) => {
          this.isAdmin = profile.role?.toLowerCase() === 'admin';
          this.username = profile.firstName!;
          this.avatar = profile.photo || null;
        })
      )
      .subscribe();
  }
}
